/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Checkbox } from '@atoms';
import { Form } from '@organisms';

const CheckboxField = ({ disabled, label, labelStyle, labelClassName, ...props }) => {
  return (
    <Form.Item valuePropName="checked" {...props}>
      <Checkbox disabled={disabled} style={labelStyle} className={labelClassName}>
        {label}
      </Checkbox>
    </Form.Item>
  );
};

export default CheckboxField;
